import { APIVersionConfig } from 'src/api-versions/api-version-config-uat';
import packageInfo from "package.json";
/**
 * @file environment.uat.ts
 */
export const environment = {
  envName: 'uat',
  production: false,
  b2cForgotPassFlow:
    'https://myportaluat.b2clogin.com/myportaluat.onmicrosoft.com/oauth2/v2.0/authorize?p=B2C_1_PasswordReset&client_id=186dbe5f-8977-4f55-920a-cdc4a245a7af&nonce=defaultNonce&redirect_uri=' +
    window.location.origin +
    '&scope=openid&response_type=id_token&prompt=login',
  baseUrl: 'https://eh-or-apim-uat.azure-api.net/api/bap/api',
  b2cSignInSignUpFlow:
    'https://myportaluat.b2clogin.com/myportaluat.onmicrosoft.com/oauth2/v2.0/authorize?p=B2C_1_SignUpSignIn&client_id=186dbe5f-8977-4f55-920a-cdc4a245a7af&nonce=defaultNonce&redirect_uri=' +
    window.location.origin +
    '&scope=openid&response_type=id_token&prompt=login',
  bloblink:
    'https://ehcacustomuiuat.blob.core.windows.net/termsofuser/Empirx%20Health%20Reporting%20Portal%20-%20Terms%20Of%20Use.pdf',
  connectionString:
    'InstrumentationKey=af59f029-1f02-4bfa-bbba-ab3e7dd7fad7;IngestionEndpoint=https://eastus-8.in.applicationinsights.azure.com/;LiveEndpoint=https://eastus.livediagnostics.monitor.azure.com/;ApplicationId=4cd2f444-1dc9-452f-9a67-7fdb7f15abb4',
  googleApiKey: 'AIzaSyBfo9a3aDoFj_C9TyCowJa2g7Dq7pVpkSI',
  googleMapId: '2ea66f65a21a513d',
  apiGatewayBaseURL: 'https://eh-or-apim-uat.azure-api.net/api/bap',
  apiWordpressBaseUrl: 'https://eh-or-apim-uat.azure-api.net/wordpress',
  ocpApimSubscriptionKey: '21adba1d19e34869b85892e3707483ce',
  //   ocpApimSubscriptionKey: '4be0f7ce94df456aafe7258b64d3a0ce',
  wordpressSubscriptionKey: '21adba1d19e34869b85892e3707483ce',
  scApiSubscriptionKey: '21adba1d19e34869b85892e3707483ce',
  trediumUrl: 'https://epx-pharm-test.tredium.com/#/',
  apiVersionConfig: APIVersionConfig,
  appVersion: packageInfo.version,
};
